import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { DialogContent, IconButton } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { getPopularAndMyTimersFromServer } from 'src/consumer/services/featureServices'
import {
  PracticeTimerCongratulatoryDialogComponent,
  PracticeTimerCongratulatoryDialogPaper,
} from '../TimerComponent/styledComponents'
import AddPracticeController from './AddPractice/AddPracticeController'
import StreakPage from './StreakPage/StreakPage'
import { CongratulatoryTimerHeader } from './styledComponents'
import { TimerCongratulatoryFlowPageStates } from './utils'

export default function TimerCongratulatoryFlow({
  openDialog,
  backToPreviousPage,
  clientSessionId,
  clientCreatedTime,
  timerTitle,
  timerDuration,
  timerMinDuration,
  timerMaxDuration,
  timerBellType,
  timerType,
  timerId,
}) {
  const [pageStateStack, setPageStateStack] = useState([TimerCongratulatoryFlowPageStates.STREAK])
  const [myTimers, setMyTimers] = useState()
  const [loadingMyTimers, setLoadingMyTimers] = useState(false)

  const pageState =
    pageStateStack?.[pageStateStack.length - 1] || TimerCongratulatoryFlowPageStates.STREAK

  function popPageStack() {
    setPageStateStack((prev) => {
      const newStack = [...prev]
      newStack.pop()
      if (newStack.length === 0) {
        return [TimerCongratulatoryFlowPageStates.STREAK]
      }
      return newStack
    })
  }

  const PageComponent = useMemo(() => {
    switch (pageState) {
      case TimerCongratulatoryFlowPageStates.STREAK:
        return StreakPage
      case TimerCongratulatoryFlowPageStates.ADD_PRACTICE:
        return AddPracticeController
      default:
        return React.Fragment
    }
  }, [pageState])

  const HeaderTitle = useMemo(() => {
    switch (pageState) {
      case TimerCongratulatoryFlowPageStates.STREAK:
        return 'Congratulations! 🎉'
      case TimerCongratulatoryFlowPageStates.ADD_PRACTICE:
        return 'Add Practice'
      default:
        return null
    }
  }, [pageState])

  async function getMyTimers() {
    const dataToSet = await getPopularAndMyTimersFromServer()
    setMyTimers(dataToSet)
  }

  async function Setup() {
    setLoadingMyTimers(true)
    const promises = [getMyTimers()]
    await Promise.all(promises)
    setLoadingMyTimers(false)
  }

  function setNextPageState(nextPageString) {
    setPageStateStack((prev) => [...prev, nextPageString])
  }

  useEffect(() => {
    Setup()
  }, [])

  return (
    <PracticeTimerCongratulatoryDialogComponent
      open={openDialog}
      PaperComponent={PracticeTimerCongratulatoryDialogPaper}
      PaperProps={{
        longDialog: pageState !== TimerCongratulatoryFlowPageStates.STREAK,
      }}
    >
      <CongratulatoryTimerHeader>
        <IconButton
          onClick={popPageStack}
          disabled={pageStateStack?.length <= 1}
          sx={{ opacity: pageStateStack?.length > 1 ? 1 : 0, color: '#fff' }}
        >
          <ArrowBackIcon />
        </IconButton>
        <div>{HeaderTitle}</div>
        <IconButton
          disableRipple
          disabled
          sx={{ color: 'transparent', opacity: 0 }}
          onClick={popPageStack}
        >
          <ArrowBackIcon />
        </IconButton>
      </CongratulatoryTimerHeader>
      <DialogContent>
        <PageComponent
          myTimers={myTimers}
          setMyTimers={setMyTimers}
          clientSessionId={clientSessionId}
          clientCreatedTime={clientCreatedTime}
          backToPreviousPage={backToPreviousPage}
          isNotAnonymous={!!timerId}
          timerId={timerId}
          setNextPageState={setNextPageState}
          {...{
            timerTitle,
            timerDuration,
            timerMinDuration,
            timerMaxDuration,
            timerBellType,
            timerType,
            timerPreferredTimes: [],
          }}
        />
      </DialogContent>
    </PracticeTimerCongratulatoryDialogComponent>
  )
}
